var _circle, _circle2, _path, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCommunicationIt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#FF5A26"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 24,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4236 54.7753C14.5 41 26.5 12 54.0542 20.3933C53.3744 23.3146 48.8424 45.3371 22.1034 54.7753M11 31.8539C25.0493 27.809 43.6305 30.7303 57 44.4382M21.4236 15C30.0345 16.3483 52.3287 26.236 48.6158 55",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 20,
    r: 3.25,
    fill: "#FF5A26",
    stroke: "white",
    strokeWidth: 1.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 15,
    r: 3.25,
    fill: "#FF5A26",
    stroke: "white",
    strokeWidth: 1.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 32,
    r: 3.25,
    fill: "#FF5A26",
    stroke: "white",
    strokeWidth: 1.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 56,
    r: 3.25,
    fill: "#FF5A26",
    stroke: "white",
    strokeWidth: 1.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 56,
    r: 3.25,
    fill: "#FF5A26",
    stroke: "white",
    strokeWidth: 1.5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 45,
    r: 3.25,
    fill: "#FF5A26",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCommunicationIt);
export default __webpack_public_path__ + "static/media/iconCommunicationIT.8e6cde732da9f2c89bf02adb1a596d30.svg";
export { ForwardRef as ReactComponent };